import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { usePlaylists, usePlaylistMutations } from "../lib/playlists";
import { Button, EmptyState, Spinner } from "../components/ui";
import { Icon } from "../components/icons";

export default function Playlists() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const q = usePlaylists(user?.id);
  const { create, remove } = usePlaylistMutations();
  const lists = q.data || [];

  const add = () => {
    const name = window.prompt("Nome da nova lista:", "A minha lista");
    if (!name?.trim()) return;
    create.mutate({ name: name.trim(), song_ids: [] }, { onSuccess: (p) => navigate(`/listas/${p.id}`), onError: (e) => window.alert(e.message) });
  };
  const del = (p) => {
    if (!window.confirm(`Eliminar a lista "${p.name}"?`)) return;
    remove.mutate(p.id, { onError: (e) => window.alert(e.message) });
  };

  return (
    <>
      <div className="page-header" style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button className="icon-btn" aria-label="Voltar" onClick={() => navigate(-1)}><Icon name="chevron-back" size={22} /></button>
        <h1 className="t-h1" style={{ flex: 1, fontSize: 26 }}>As minhas listas</h1>
        <Button className="auto sm" icon="add" loading={create.isPending} onClick={add} data-testid="playlist-new-button">NOVA LISTA</Button>
      </div>
      <div className="page ulc-fade" style={{ maxWidth: 820 }}>
        <div className="t-hint" style={{ marginBottom: 14 }} data-testid="playlists-sync-note">
          As suas listas ficam guardadas na sua conta e aparecem também na app Mobile.
        </div>
        {q.isLoading ? <Spinner /> : null}
        {q.isError ? <EmptyState icon="alert-circle-outline" text={q.error.message} testid="playlists-error" /> : null}
        {q.isSuccess && !lists.length ? <EmptyState icon="list-music" text="Ainda não criou nenhuma lista." testid="playlists-empty" /> : null}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {lists.map((p) => (
            <div key={p.id} className="card" style={{ display: "flex", alignItems: "center", gap: 12, padding: 12 }} data-testid={`playlist-row-${p.id}`}>
              <div style={{ width: 40, height: 40, borderRadius: 999, background: "var(--brand-tertiary)", display: "flex", alignItems: "center", justifyContent: "center" }}><Icon name="list-music" size={18} /></div>
              <button onClick={() => navigate(`/listas/${p.id}`)} style={{ flex: 1, minWidth: 0, background: "none", border: "none", color: "inherit", textAlign: "left", cursor: "pointer" }} data-testid={`playlist-open-${p.id}`}>
                <div style={{ fontFamily: "var(--f-medium)", fontSize: 15 }}>{p.name}</div>
                <div className="t-hint">{p.song_ids.length} {p.song_ids.length === 1 ? "música" : "músicas"}</div>
              </button>
              <button className="icon-btn" aria-label={`Eliminar ${p.name}`} onClick={() => del(p)} data-testid={`playlist-delete-${p.id}`}><Icon name="trash" size={16} color="var(--muted)" /></button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
